const { VITE_APP_CLOUDFRONT_URL, VITE_APP_STORAGE_BUCKET_URL } = import.meta.env;

export function getMediaLink({ link, size }: { link?: string; size?: number }) {
  if (!link) {
    return "";
  }

  const isValidUrl = typeof URL.canParse === "function" && URL.canParse(link);
  const isStorageBucketUrl = link.startsWith(`${VITE_APP_STORAGE_BUCKET_URL}`);

  // If it's a valid URL and not from storage bucket, return as is
  if (isValidUrl && !isStorageBucketUrl) {
    return link;
  }

  // For relative links or storage bucket URLs, use CloudFront with size parameter
  if (size) {
    const path = isStorageBucketUrl ? link.replace(`${VITE_APP_STORAGE_BUCKET_URL}/`, "") : link;
    return `${VITE_APP_CLOUDFRONT_URL}/${path}?width=${size}`;
  }

  // Fallback to storage bucket URL without size parameter
  return `${VITE_APP_STORAGE_BUCKET_URL}/${link}`;
}
